import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { NavbarComponent } from './shared/components/navbar/navbar.component';
import { FooterComponent } from './shared/components/footer/footer.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  imports: [CommonModule, RouterModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {

  title = 'lote-3-web-app';

  constructor(private translate: TranslateService, private router: Router) {
    this.translate.addLangs(['es', 'en']);
    this.translate.setDefaultLang('es');
    this.translate.use('es');
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        const scrollToTop = () => {
          const position = window.pageYOffset;
          if (position > 0) {
            // Scroll más rápido: aumentar la velocidad con un factor mayor
            window.scrollTo(0, position - Math.max(40, position / 30));
            // Continuar el proceso de scroll
            window.requestAnimationFrame(scrollToTop);
          }
        };
        
        // Iniciar la animación de scroll
        window.requestAnimationFrame(scrollToTop);
      }
    });
  }
}
